import React, { CSSProperties, FunctionComponent, useMemo } from 'react';

import { SellingProposition } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';

import BackdropImage from '../../../BackdropImage';
import Subtitle from '../../../Section/SellingPropositionList/Image/Subtitle';
import Title from '../../../Section/SellingPropositionList/Image/Title';

const useStyles = () => {
  const { breakpoint, spacing } = useTheme();

  return useMemo(() => {
    return {
      root: {
        height: '60vh',
        boxSizing: 'border-box',
        width: `calc(100% - ${spacing(4)})`,
        margin: spacing(2),
        borderRadius: spacing(2),
        overflow: 'hidden',
        [breakpoint.up('md')]: {
          height: 'auto',
          minHeight: spacing(64),
          width: spacing(64),
          margin: spacing(2),
        },
      },
    } as const;
  }, [breakpoint, spacing]);
};

export interface ImageProps extends SellingProposition {
  imgStyle?: CSSProperties;
}

const Image: FunctionComponent<ImageProps> = (props) => {
  const { title, text, image } = props;
  const { asset, alt, hotspot } = image || {};

  const gatsbyImageData = asset.localFile.childImageSharp.gatsbyImageData;
  const classes = useStyles();

  return (
    <Flex>
      <BackdropImage css={classes.root} alt={alt} hotspot={hotspot} image={gatsbyImageData}>
        <Title level={title?.level}>{title?.title}</Title>

        <Subtitle>{text}</Subtitle>
      </BackdropImage>
    </Flex>
  );
};

export default Image;
